<template>
  <div>
    <div id="page">
      <el-button-group>
        <el-button type="primary" icon="el-icon-refresh" size="small" @click="search">刷新</el-button>
        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="addFun">新增</el-button>
        <el-button type="primary" icon="el-icon-edit" size="small" @click="editFun">编辑</el-button>
        <el-button type="primary" icon="el-icon-caret-bottom" size="small" @click="expansionFun(tableData, true)">展开</el-button>
        <el-button type="primary" icon="el-icon-caret-right" size="small" @click="expansionFun(tableData, false)">折叠</el-button>
        <el-button type="danger" icon="el-icon-delete" size="small" @click="delFun">删除</el-button>
      </el-button-group>
      <el-table :data="tableData" row-key="id" ref="tableData" @current-change="selectRow" border size="small" stripe height="200" highlight-current-row v-loading="isLoading">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
<!--        <el-table-column prop="id" label="ID" align="center" show-overflow-tooltip></el-table-column>-->
        <el-table-column prop="name" label="名称" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column prop="code" label="编码" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="value" label="值" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sort" label="排序" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" width="300" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <AddOrUpdate ref="addOrUpdate" :refresh="search"/>
  </div>
</template>

<script>
import AddOrUpdate from './AddOrUpdate'

export default {
  name: 'ConfigList',
  components: {AddOrUpdate},
  data () {
    return {
      //加载层显示
      isLoading: false,
      //表格数据
      tableData: [],
      //当前选中行
      currentRow: null
    }
  },
  methods: {
    //查询数据
    search: function () {
      this.isLoading = true
      this.$axios.get('/sysConfig/getAll').then(response => {
        this.isLoading = false
        //取消选中行(树形结构时改变方法存在Bug,此处手动处理)
        this.$refs.tableData.setCurrentRow(-1);
        this.currentRow = null
        //数据更新
        this.tableData = this.$utils.convertTree(response)
      }).catch(error => {
        this.isLoading = false
      })
    },
    //选中行改变
    selectRow: function (currentRow) {
      this.currentRow = currentRow
    },
    //新增
    addFun: function () {
      this.$refs.addOrUpdate.isDialog = true
      this.$refs.addOrUpdate.title = '新增'
      if(this.currentRow){
        this.$refs.addOrUpdate.config.parentId = this.currentRow.id
      }
    },
    //编辑
    editFun: function () {
      if (this.currentRow) {
        this.$refs.addOrUpdate.isDialog = true
        this.$refs.addOrUpdate.title = '编辑'
        this.$refs.addOrUpdate.config = JSON.parse(JSON.stringify(this.currentRow))
      } else {
        this.$message.info('请先选择需要编辑的数据！')
      }
    },
    //删除
    delFun: function () {
      if (this.currentRow) {
        //确认删除
        this.$confirm(this.currentRow.children && this.currentRow.children.length > 0 ?'删除数据时会删除包含的全部子节点，确认删除？' : '确认删除当前选中数据？', '提示', {
          type: 'warning'
        }).then(() => {
          //删除数据
          this.$axios.get('/sysConfig/deleteDeep', {
            params: {
              id: this.currentRow.id
            }
          }).then(response => {
            this.search()
            this.$message.success('删除成功~')
          })
        })
      } else {
        this.$message.info('请先选择需要删除的数据！')
      }
    },
    //全部展开或折叠
    expansionFun: function(data, isOpen){
      data.forEach(row => {
        if(row.children && row.children.length > 0){
          this.$refs.tableData.toggleRowExpansion(row, isOpen)
          this.expansionFun(row.children, isOpen)
        }
      })
    }
  },
  mounted () {
    //加载完成后动态计算表格的高度
    this.$nextTick(() => {
      $('.el-table').css({
        height: $('#page').height() - 37
      })
    })
    //查询表格数据
    this.search()
  }
}
</script>

<style scoped>
#page {
  padding: 10px;
  height: calc(100% - 20px);
}

.el-button-group {
  margin: 0 0 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/system/config/ConfigList.vue